import { requestJson } from "@/utils/http";

/**
 * @param {string} apiHost
 * @param {Record<string, string>} headers
 */
export const getUserInfo = (apiHost, headers) =>
  requestJson(apiHost + "/api/user", { headers });
